<template>
  <div class="view-check">
    <Banner>
      <h2 class="banner-title">基于工商大数据智能在线核名系统</h2>
    </Banner>
    <FormWrap class="banner-form" :scrollFixed="true">
      <FormItem type="location">
        <Location></Location>
      </FormItem>
      <FormItem type="font">
        <el-input
          class="inline-input"
          v-model="font"
          placeholder="字号信息"
          size="small"
          style="width: 226px"
          maxlength="6"
        ></el-input>
      </FormItem>
      <FormItem type="industry">
        <Industry placeholder="行业类型" style="width: 247px"></Industry>
      </FormItem>
      <FormItem type="org">
        <el-select
          size="small"
          v-model="companyType"
          placeholder="组织形式"
          style="width: 247px"
        >
          <el-option
            v-for="item in orgList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </FormItem>
      <el-button class="form-btn" type="primary" @click="checkHandle">
        一键核名
      </el-button>
      <p class="com-form-con-link" v-if="!isMini">
        <router-link to="/">获取更多公司名称，去起名 >>></router-link>
      </p>
    </FormWrap>
    <el-dialog
      title="请选择您的公司名称，查看核名结果"
      :visible.sync="$store.state.checkSelectDialogStatus"
      :append-to-body="true"
      class="check-select-dialog"
    >
      <ul>
        <li>
          <p ref="company-name-1">
            <span>{{ locationStr }}</span>
            <span class="font-box">{{ font }}</span>
            <span>{{ $store.state.industry }}</span>
            <span>{{ companyStr }}</span>
          </p>
          <el-button
            type="primary"
            @click="handleClick('company-name-1')"
            size="small"
          >
            核名
          </el-button>
        </li>
        <li>
          <p ref="company-name-2">
            <span class="font-box">{{ font }}</span>
            <span>（{{ locationStr }}）</span>
            <span>{{ $store.state.industry }}</span>
            <span>{{ companyStr }}</span>
          </p>
          <el-button
            type="primary"
            @click="handleClick('company-name-2')"
            size="small"
          >
            核名
          </el-button>
        </li>
        <li>
          <p ref="company-name-3">
            <span class="font-box">{{ font }}</span>
            <span>{{ $store.state.industry }}</span>
            <span>（{{ locationStr }}）</span>
            <span>{{ companyStr }}</span>
          </p>
          <el-button
            type="primary"
            @click="handleClick('company-name-3')"
            size="small"
          >
            核名
          </el-button>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapMutations, mapState, mapActions } from "vuex";
import Banner from "../components/Banner.vue";
import FormWrap from "../components/FormWrap";
import FormItem from "../components/FormItem.vue";
import orgList from "../utils/orgList";
import Location from "../components/Location";
import Industry from "../components/Industry";
import wx from 'weixin-js-sdk'

export default {
  name: "check",
  components: {
    Industry,
    Location,
    Banner,
    FormItem,
    FormWrap
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin
    }),
    locationStr() {
      return this.$store.state.location.c_title.replace("市", "");
    },
    companyStr() {
      const result = orgList.find(v => {
        if (this.companyType === v.value) {
          return v.label;
        }
      });
      return result.label;
    }
  },
  data() {
    return {
      restaurants: [],
      font: "",
      orgList,
      companyType: "3",
      wx:wx,
      isMini:false,
      phone:'',
    };
  },
  methods: {
    ...mapMutations([
      "setLoginDialogStatus",
      "setRegisterDialogStatus",
      "setCheckSelectDialogStatus",
      "setGiveNameResultDialogStatus"
    ]),
    ...mapActions(["getCheckNameViewNew",'registerHeming']),
    checkHandle() {
      // 截取手机号
      let url = window.location.href;
      console.log(url,'url')
      this.phone = this.GetQueryString(url, 'phone');
      if (this.phone && this.isMini) {
        localStorage.setItem('isLogin', 'success');
        this.$store.commit('setLoginStatusNew', true);
      } 
      if (this.isMini && !this.phone) {
        wx.miniProgram.navigateTo({url: "/pages/login/index"})
        return;
      }
      if (!this.$store.state.location.c_id) {
        return this.$message({
          type: "error",
          message: "请选择城市"
        });
      }
      if (!this.font) {
        return this.$message({
          type: "error",
          message: "请添加字号"
        });
      } else if (!/^[\u4E00-\u9FA5]+$/gi.test(this.font)) {
        return this.$message({
          type: "error",
          message: "字号请输入简体中文"
        });
      }
      if (!this.$store.state.industry) {
        return this.$message({
          type: "error",
          message: "请选择行业"
        });
      }
      
      if (this.isLogin) {
        this.setCheckSelectDialogStatus(true);
        if(this.isMini && this.phone){
          this.registerHeming({
            phone:this.phone,
            city_name:'北京',
            source:'xcx-hm-bj',
            activity_name : "牛牛帮小程序核名活动",
            advertiser_id : '1234567',
            user_tag_ids:1643,
            remark:"公众号-小程序核名"
          }).then(res => {
            if (res.data.status) {
              console.log('小程序核名成功')
              // this.setCheckSelectDialogStatus(false);
              // this.setGiveNameResultDialogStatus(true);
            } else {
              this.$message({
                type: "error",
                message: res.data.result
              });
            }
          });
        }
      } else {
        this.setRegisterDialogStatus({ status: true, isSimple: true });
      }
    },
    handleClick(ref) {
      // this.getCheckNameViewNew({
      //   cityId: this.$store.state.location.c_id,
      //   city: this.$store.state.location.c_title,
      //   industryId: this.$store.state.industry.i_id,
      //   industry: this.$store.state.industry,
      //   cityGroup: 1,
      //   companyType: this.companyType,
      //   hotword: this.font,
      //   sub_content: "落地页",
      //   sub_button: "免费核名",
      //   companyName: this.$refs[ref].innerText
      // }).then(res => {
      //   if (res.data.status) {
      //     this.setGiveNameResultDialogStatus(true);
      //   } else {
      //     this.$message({
      //       type: "error",
      //       message: res.data.result
      //     });
      //   }
      // });
      this.getCheckNameViewNew({
        //   // cityId: this.$store.state.location.c_id,
        //   city: this.$store.state.location,
        //   // industryId: this.$store.state.industry.i_id,
        //   industry: this.$store.state.industry,
        //   cityGroup: 1,
        //   companyType: this.companyType,
        //   hotword: this.font,
        //   sub_content: "落地页",
        //   sub_button: "免费核名",
        word: this.font,
        company_name: this.$refs[ref].innerText
      }).then(res => {
        if (res.data.status) {
          this.setGiveNameResultDialogStatus(true);
        } else {
          this.$message({
            type: "error",
            message: res.data.result
          });
        }
      });
    },
    GetQueryString(url, name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = url.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
  watch: {},
  mounted() {
    document.title = "公司核名";
  },
  created() {
    // 区分来源
    if (this.$route.path === '/heming') {
      this.isMini = true;
    }else{
      this.isMini = false;
    }
  }
};
</script>
<style lang="scss">
.view-check {
  .banner-title {
    text-align: center;
    font-size: 20px;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 4px 6px rgba(4, 0, 0, 0.2);
    padding: 30px 0 24px;
    line-height: 1;
  }
  .banner-form {
    margin-bottom: 54px;
    .select-location,
    .select-industry {
      .select-text,
      .select-text i {
        height: 48px;
        line-height: 48px;
      }
    }
  }
  .banner-tip {
    text-align: center;
    font-size: 18px;
    line-height: 1;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 4px 6px rgba(4, 0, 0, 0.2);
  }
  .com-form-wrap {
    width: 86%;
    margin: -170px auto 0;
    background: #fff;
    position: relative;
    border-radius: 4px;
  }
}
.check-select-dialog {
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog {
    width: 412px;
  }
  .el-dialog__body {
    padding-top: 6px;
  }
  .el-dialog__body {
    ul {
      border-top: 1px solid rgba(229, 229, 229, 1);
      padding: 20px 0 0;
    }
    li {
      margin-bottom: 14px;
      overflow: hidden;
      width: 100%;
      font-size: 16px;
      line-height: 32px;
      color: #333333;
      display: flex;
      /*position: relative;*/
      flex-direction: row;
      justify-content: space-between;
      p {
        /*margin-right: 56px;*/
      }
      .el-button {
        /*right: 0;*/
        /*position: absolute;*/
        /*top: 0;*/
        height: 32px;
      }
      .font-box {
        color: #ff0000;
      }
    }
  }
}
</style>
